import React, { useState } from 'react';
import { getFileType } from '../../utilities/parsers';

const MaterialAdminModal = ({
  displayModal,
  closeModal,
  conciliationFiles,
  handleUpdateFile,
  handleDeleteFile,
  downloadFile,
  orderId,
}) => {
  const [listTable, setListTable] = useState(true);
  const [deleteWarning, setDeleteWarning] = useState(false);
  const [deleteFile, setDeleteFile] = useState({});
  const [observations, setObservations] = useState('');

  const handleDeleteModal = (file) => {
    setDeleteWarning(true);
    setListTable(false);
    setDeleteFile(file);
  };

  const deleteFileHelper = (observations) => {
    handleDeleteFile(deleteFile.id, observations);
    manageCloseModal();
  };

  const manageCloseModal = () => {
    setDeleteWarning(false);
    setListTable(true);
    setDeleteFile({});
    setObservations('');
    closeModal();
  };

  // Helper function para obtener icono de tipo de archivo
  const getFileIcon = (fileName) => {
    const extension = fileName?.split('.').pop()?.toLowerCase();
    const iconMap = {
      pdf: 'fas fa-file-pdf has-text-danger',
      doc: 'fas fa-file-word has-text-primary',
      docx: 'fas fa-file-word has-text-primary',
      xls: 'fas fa-file-excel has-text-success',
      xlsx: 'fas fa-file-excel has-text-success',
      jpg: 'fas fa-file-image has-text-warning',
      jpeg: 'fas fa-file-image has-text-warning',
      png: 'fas fa-file-image has-text-warning',
      zip: 'fas fa-file-archive has-text-info',
      rar: 'fas fa-file-archive has-text-info',
      txt: 'fas fa-file-alt has-text-grey',
      default: 'fas fa-file has-text-grey'
    };
    return iconMap[extension] || iconMap.default;
  };

  // Helper function para el badge de tipo de adjunto
  const getAttachmentTypeBadge = (typeName) => {
    const typeMap = {
      'Programación': 'is-info',
      'Transmisión': 'is-warning', 
      'Testigo': 'is-success',
      'General': 'is-primary'
    };
    
    const badgeClass = typeMap[typeName] || 'is-light';
    
    return (
      <span className={`tag ${badgeClass}`}>
        {typeName}
      </span>
    );
  };

  // Helper function para el estado del archivo
  const getFileStatus = (file) => {
    if (file.accepted) {
      return (
        <span className="tag is-success is-light">
          <span className="icon is-small mr-1">
            <i className="fas fa-check-circle"></i>
          </span>
          <span>Aceptado</span>
        </span>
      );
    }
    return (
      <span className="tag is-warning is-light">
        <span className="icon is-small mr-1">
          <i className="fas fa-clock"></i>
        </span>
        <span>Pendiente</span>
      </span>
    );
  };

  return (
    <div className={`modal ${displayModal ? 'is-active' : ''}`}>
      <div className="modal-background" onClick={manageCloseModal}></div>
      <div className="modal-card" style={{ width: '95vw', maxWidth: '1200px', maxHeight: '90vh' }}>
        <header className="modal-card-head has-background-primary">
          <p className="modal-card-title has-text-white">
            <span className="icon mr-2">
              <i className="fas fa-paperclip"></i>
            </span>
            Adjuntos de Usuario
          </p>
          <button 
            className="delete is-large" 
            aria-label="close" 
            onClick={manageCloseModal}
          ></button>
        </header>

        {listTable && (
          <section className="modal-card-body">
            <div className="level mb-4">
              <div className="level-left">
                <div className="level-item">
                  <div>
                    <h3 className="title is-5 mb-1">
                      <span className="icon mr-2 has-text-primary">
                        <i className="fas fa-folder-open"></i>
                      </span>
                      Archivos Cargados
                    </h3>
                    <p className="subtitle is-6 has-text-grey mb-0">
                      {conciliationFiles.length} archivo{conciliationFiles.length !== 1 ? 's' : ''} disponible{conciliationFiles.length !== 1 ? 's' : ''}
                    </p>
                  </div>
                </div>
              </div>
              <div className="level-right">
                <div className="level-item">
                  <div className="tags">
                    <span className="tag is-light">
                      <span className="icon is-small mr-1">
                        <i className="fas fa-info-circle"></i>
                      </span>
                      <span>Revisar y aprobar</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {conciliationFiles.length === 0 ? (
              <div className="has-text-centered py-6">
                <span className="icon-text has-text-grey">
                  <span className="icon is-large mr-3">
                    <i className="fas fa-inbox fa-2x"></i>
                  </span>
                  <span className="is-size-5">No hay archivos disponibles</span>
                </span>
              </div>
            ) : (
              <div className="table-container">
                <table className="table is-bordered is-fullwidth is-hoverable mb-0">
                  <thead>
                    <tr className="has-background-light">
                      <th>
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fas fa-file"></i>
                          </span>
                          <span>Archivo</span>
                        </span>
                      </th>
                      <th>
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fas fa-tag"></i>
                          </span>
                          <span>Tipo</span>
                        </span>
                      </th>
                      <th>
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fas fa-align-left"></i>
                          </span>
                          <span>Descripción</span>
                        </span>
                      </th>
                      <th>
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fas fa-layer-group"></i>
                          </span>
                          <span>Categoría</span>
                        </span>
                      </th>
                      <th>
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fas fa-broadcast-tower"></i>
                          </span>
                          <span>Medio</span>
                        </span>
                      </th>
                      <th>
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fas fa-info-circle"></i>
                          </span>
                          <span>Estado</span>
                        </span>
                      </th>
                      <th className="has-text-centered">
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fas fa-cogs"></i>
                          </span>
                          <span>Acciones</span>
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {conciliationFiles.map((file, index) => (
                      <tr key={index} className="is-size-7">
                        <td>
                          <div className="is-flex is-align-items-center">
                            <span className={`icon mr-2 ${getFileIcon(file.name)}`}>
                              <i className={getFileIcon(file.name)}></i>
                            </span>
                            <button 
                              className="button is-ghost is-small has-text-weight-semibold" 
                              onClick={(e) => downloadFile(e, file)}
                              title="Descargar archivo"
                            >
                              {file.name}
                            </button>
                          </div>
                        </td>
                        <td>
                          <span className="tag is-light is-small">
                            {getFileType(file?.name)}
                          </span>
                        </td>
                        <td className="has-text-weight-semibold">
                          {file.description || 
                            <span className="has-text-grey-light is-italic">Sin descripción</span>
                          }
                        </td>
                        <td>
                          {getAttachmentTypeBadge(file.type_name)}
                        </td>
                        <td>
                          <span className="tag is-info is-light is-small">
                            {file.media}
                          </span>
                        </td>
                        <td>
                          {getFileStatus(file)}
                        </td>
                        <td>
                          <div className="field is-grouped is-grouped-centered">
                            <div className="control">
                              <button
                                className="button is-success is-small"
                                disabled={file.accepted}
                                onClick={() => handleUpdateFile(file.id)}
                                title={file.accepted ? 'Ya está aceptado' : 'Aceptar archivo'}
                              >
                                <span className="icon is-small mr-1">
                                  <i className="fas fa-check"></i>
                                </span>
                                <span>Aceptar</span>
                              </button>
                            </div>
                            <div className="control">
                              <button
                                className="button is-danger is-small"
                                onClick={() => handleDeleteModal(file)}
                                title="Rechazar archivo"
                              >
                                <span className="icon is-small mr-1">
                                  <i className="fas fa-times"></i>
                                </span>
                                <span>Rechazar</span>
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </section>
        )}

        {deleteWarning && (
          <section className="modal-card-body">
            <div className="notification is-warning is-light mb-4">
              <div className="level">
                <div className="level-left">
                  <div className="level-item">
                    <span className="icon-text">
                      <span className="icon mr-2 has-text-warning">
                        <i className="fas fa-exclamation-triangle"></i>
                      </span>
                      <span className="has-text-weight-semibold">Confirmar Rechazo de Archivo</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {deleteFile.accepted && (
              <div className="notification is-danger is-light mb-4">
                <span className="icon-text">
                  <span className="icon mr-2">
                    <i className="fas fa-exclamation-circle"></i>
                  </span>
                  <span>
                    <strong>Atención:</strong> El adjunto que está intentando rechazar ha sido aceptado 
                    anteriormente. Por favor, especifique claramente el motivo del rechazo en las observaciones.
                  </span>
                </span>
              </div>
            )}

            <div className="card mb-4">
              <header className="card-header">
                <p className="card-header-title">
                  <span className="icon mr-2">
                    <i className="fas fa-comment-alt"></i>
                  </span>
                  Observaciones del Rechazo
                </p>
              </header>
              <div className="card-content">
                <div className="field">
                  <label className="label has-text-weight-semibold">
                    Motivo del rechazo <span className="has-text-danger">*</span>
                  </label>
                  <div className="control">
                    <textarea
                      className={`textarea ${observations.length === 0 ? 'is-danger' : 'is-success'}`}
                      placeholder="Ingrese el motivo detallado del rechazo..."
                      value={observations}
                      onChange={(e) => setObservations(e.target.value)}
                      rows="3"
                    ></textarea>
                  </div>
                  {observations.length === 0 && (
                    <p className="help is-danger">
                      <span className="icon is-small mr-1">
                        <i className="fas fa-exclamation-circle"></i>
                      </span>
                      Las observaciones son obligatorias para rechazar un archivo
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div className="card">
              <header className="card-header">
                <p className="card-header-title">
                  <span className="icon mr-2">
                    <i className="fas fa-file-times"></i>
                  </span>
                  Archivo a Rechazar
                </p>
              </header>
              <div className="card-content">
                <div className="table-container">
                  <table className="table is-bordered is-fullwidth mb-0">
                    <thead>
                      <tr className="has-background-danger-light">
                        <th>Archivo</th>
                        <th>Tipo</th>
                        <th>Descripción</th>
                        <th>Categoría</th>
                        <th>Medio</th>
                        <th className="has-text-centered">Acción</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr key={deleteFile.id}>
                        <td>
                          <div className="is-flex is-align-items-center">
                            <span className={`icon mr-2 ${getFileIcon(deleteFile.name)}`}>
                              <i className={getFileIcon(deleteFile.name)}></i>
                            </span>
                            <button
                              className="button is-ghost is-small has-text-weight-semibold"
                              onClick={(e) => downloadFile(e, deleteFile)}
                            >
                              {deleteFile.name}
                            </button>
                          </div>
                        </td>
                        <td>
                          <span className="tag is-light is-small">
                            {getFileType(deleteFile?.name)}
                          </span>
                        </td>
                        <td className="has-text-weight-semibold">
                          {deleteFile.description || 
                            <span className="has-text-grey-light is-italic">Sin descripción</span>
                          }
                        </td>
                        <td>
                          {getAttachmentTypeBadge(deleteFile.type_name)}
                        </td>
                        <td>
                          <span className="tag is-info is-light is-small">
                            {deleteFile.media}
                          </span>
                        </td>
                        <td className="has-text-centered">
                          <button
                            disabled={observations.length === 0}
                            className={`button is-danger ${observations.length === 0 ? '' : 'is-focused'}`}
                            onClick={() => deleteFileHelper(observations)}
                          >
                            <span className="icon is-small mr-1">
                              <i className="fas fa-ban"></i>
                            </span>
                            <span>Confirmar Rechazo</span>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        )}

        <footer className="modal-card-foot">
          <div className="level is-fullwidth">
            <div className="level-left">
              <div className="level-item">
                {!deleteWarning && (
                  <p className="has-text-grey is-size-7">
                    <span className="icon is-small mr-1">
                      <i className="fas fa-lightbulb"></i>
                    </span>
                    Haz clic en los nombres de archivo para descargarlos
                  </p>
                )}
              </div>
            </div>
            <div className="level-right">
              <div className="level-item">
                <button 
                  className="button is-light is-medium" 
                  onClick={manageCloseModal}
                >
                  <span className="icon mr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                  <span>{deleteWarning ? 'Cancelar' : 'Cerrar'}</span>
                </button>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default MaterialAdminModal;